/* eslint-disable no-eval */
import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { withSnackbar } from "notistack";
import { withRouter } from "../../../shared/hoc/withRouter";
import * as reportingClientCrud from "../../../crud/powerBIReportingClient.crud";

const isPowerBIReportingClientEnabled = process.env.REACT_APP_POWERBI_CONNECTOR_ENABLED === "true";

class RequestReportingClient extends React.Component {
  state = {
    loading: false,
    loaded: false,
    clientId: null,
    scopes: null,
    mode: null,
    secret: null,         // only set after rotate/create
    error: null
  };

  componentDidMount() {
    if (!isPowerBIReportingClientEnabled) return;
    this.loadClient();
  }

  loadClient = async () => {
    this.setState({ loading: true, error: null });

    try {
        const res = await reportingClientCrud.getReportingClient();
        const client = res?.data || null;
        const clientId = client.clientId || client.ClientId || this.state.clientId;

        if (!clientId) {
            this.setState({
                loading: false,
                loaded: true,
                clientId: null,
                scopes: null,
                mode: null,
                secret: null,
                error: null
            });
            return;
        }


        this.setState({
            loading: false,
            loaded: true,
            clientId: clientId,
            scopes: client.scopes || null,
            mode: client.mode || null,
            secret: null,
            error: null
        });
    } catch (err) {
        const errMsg = String(err?.message || "");
        if (errMsg.startsWith("404-") || errMsg.includes("Not Found")) {
            this.setState({
                loading: false,
                loaded: true,
                clientId: null,
                scopes: null,
                mode: null,
                secret: null,
                error: null
            });
            return;
        }

        const msg =
        err?.response?.data?.description ||
        err?.response?.data?.message ||
        err?.response?.data ||
        err?.message ||
        "Unable to load reporting client.";

        this.setState({
            loading: false,
            loaded: true,
            error: String(msg),
            secret: null
        });
    }
    };

  rotateOrCreate = async () => {
    if (this.state.loading) return;

    const ok = window.confirm(
      this.props.intl.formatMessage({ id: "POWERBI.CLIENT.ROTATE.CONFIRM" })
    );
    if (!ok) return;

    this.setState({ loading: true, error: null });

    try {
      const res = await reportingClientCrud.rotateReportingClientSecret();
      const data = res.data || {};

      const clientId = data.clientId || data.ClientId || this.state.clientId;
      const secret = data.clientSecret || data.ClientSecret || null;

      this.setState({
        loading: false,
        loaded: true,
        clientId: clientId || null,
        secret: secret,
      });

      setTimeout(() => {
        this.setState((s) => (s.secret ? { secret: null } : null));
      }, 60000);

    } catch (err) {
      const msg =
        err?.response?.data?.description ||
        err?.response?.data?.message ||
        err?.response?.data ||
        err?.message ||
        "Unable to generate new secret.";

      this.setState({ loading: false, error: String(msg) });
    }
  };

  copy = (elementId) => {
    const el = document.getElementById(elementId);
    if (!el) return;
    el.select();
    document.execCommand("copy");
    this.props.enqueueSnackbar("Copied", { variant: "success" });
  };

  renderDxRow = (label, valueNode) => (
    <div className="dx-field">
      <div
        className="dx-box-flex dx-box dx-widget dx-collection"
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-start",
          alignItems: "stretch"
        }}
      >
        <div className="dx-item dx-box-item" style={{ display: "flex", flex: "0 1 200px" }}>
          <div className="dx-item-content dx-box-item-content" style={{ display: "flex", flexGrow: 1 }}>
            <div className="dx-field-label" style={{ width: "100%", whiteSpace: "normal" }}>
              {label}:
            </div>
          </div>
        </div>

        <div className="dx-item dx-box-item" style={{ display: "flex", flex: "1 1 0px" }}>
          <div className="dx-item-content dx-box-item-content" style={{ display: "flex", flexGrow: 1 }}>
            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center" }}>
              <div className="dx-field-value" style={{ width: "100%", display: "flex", alignItems: "flex-start" }}>
                {valueNode}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    if (!isPowerBIReportingClientEnabled) return null;

    const title = this.props.intl.formatMessage({ id: "POWERBI.CLIENT.LABEL" });
    const btnText = this.props.intl.formatMessage({ id: "POWERBI.CLIENT.BUTTON" });
    const clientIdLabel = this.props.intl.formatMessage({ id: "POWERBI.CLIENT.CLIENTID" });
    const secretLabel = this.props.intl.formatMessage({ id: "POWERBI.CLIENT.SECRET" });

    const { loading, clientId, secret, error, scopes, mode } = this.state;

    return (
      <div style={{ width: "100%" }}>
        {/* Error */}
        {error && (
          <div style={{ color: "#c92a2a", marginBottom: 10, whiteSpace: "pre-wrap" }}>
            {error}
          </div>
        )}

        {/* ClientId row (only when exists) */}
        {clientId && this.renderDxRow(
          clientIdLabel,
          <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}>
            <input
              id="fd-pbi-clientid"
              type="text"
              readOnly
              value={clientId}
              style={{ flex: 1, padding: 10, border: "1px solid #ddd", borderRadius: 4 }}
            />
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={() => this.copy("fd-pbi-clientid")}
            >
              Copy
            </button>
          </div>
        )}

        {/* Generate/Rotate row */}
        {this.renderDxRow(
          this.props.intl.formatMessage({ id: "POWERBI.CLIENT.ACTION" }),
          <button
            type="button"
            className="btn btn-outline-primary"
            disabled={loading}
            onClick={this.rotateOrCreate}
          >
            {loading ? "Working..." : btnText}
          </button>
        )}

        {/* Secret row (only after rotate) */}
        {secret && (
          <>
            <div style={{
              marginTop: 10,
              marginBottom: 10,
              padding: 10,
              background: "#FFF4E5",
              border: "1px solid #FFD8A8",
              borderLeft: "4px solid #F59F00",
              borderRadius: 4,
              color: "#5f3b00"
            }}>
              {this.props.intl.formatMessage({ id: "POWERBI.CLIENT.SECRET.ONCE" })}
            </div>

            {this.renderDxRow(
              secretLabel,
              <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}>
                <input
                  id="fd-pbi-secret"
                  type="text"
                  readOnly
                  value={secret}
                  style={{ flex: 1, padding: 10, border: "1px solid #ddd", borderRadius: 4 }}
                />
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => this.copy("fd-pbi-secret")}
                >
                  Copy
                </button>
              </div>
            )}
          </>
        )}

        {/* Optional meta */}
        {(mode || scopes) && (
          <div style={{ marginTop: 10, color: "#666", fontSize: 13 }}>
            {mode && <div><b>Mode:</b> {mode}</div>}
            {scopes && <div style={{ marginTop: 4 }}><b>Scopes:</b> {scopes}</div>}
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(withSnackbar(injectIntl(connect()(RequestReportingClient))));